module.exports = __webpack_public_path__ + "static/media/map-icon.596ded6a.svg";